import { gql } from '@apollo/client';

export const QUERY_GET_WALLET_DETAILS = gql`
  query GetWalletDetailsV2 {
    getWalletDetailsV2 {
      message
      data {
        amount
        isAutoRechargeEnabled
      }
    }
  }
`;

export const AUTH_ME = gql`
  query authMe {
    authMe {
      message
      data {
        lastSession {
          platform
          id
          authType
          userAgent
        }
        user {
          lastPasswordResetAt
          id
          name
          email
          phoneNumber
          language
          identityProvider
          profilePicture {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          coverProfilePicture {
            createdAt
            id
            key
            mimetype
            originalname
            size
            url
          }
          roles {
            id
            label
            slug
            level
            isActive
            isDefault
          }
          uiVersion
          mfaTotpEnabled
          mfaEmailEnabled
          mfaReminderAt
        }
        userWorkspaceRole {
          role {
            id
            isActive
            label
            level
            position
            slug
          }
        }
      }
    }
  }
`;

export const QUERY_AI_DASHBOARD_INTENT = gql`
  query aiDashboardIntent(
    $intentType: String!
    $fromDate: Date!
    $toDate: Date!
    $limit: Int
    $offset: Int
    $order: String
    $sort: SortEnum
  ) {
    aiDashboardIntent(
      intentType: $intentType
      fromDate: $fromDate
      toDate: $toDate
      limit: $limit
      offset: $offset
      order: $order
      sort: $sort
    ) {
      message
      count
      edges {
        intent
        currentCount
        currentSentiment
        previousCount
        previousSentiment
        callVolume
      }
    }
  }
`;

export const WORKSPACE_AUTH_ME = gql`
  query workspaceAuthMeV2 {
    workspaceAuthMeV2 {
      message
      data {
        v2MigratedAt
        country {
          id
          name
          dialingCode
          alphaTwoCode
        }
        timezoneValue
        unreadCountWorkspace
        workspaceDetails {
          planPrice {
            amount
          }
          documents {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
        }
        id
        label
        status
        timezone
        timezoneId
        timezoneLabel

        logo {
          id
          url
        }
        providerAccount {
          systemSuspend
          status
        }
        owner {
          phoneNumber
          name
          email
          id
          profilePicture {
            id
            url
          }
          language
          roles {
            id
            label
          }
          workspaces {
            providerAccount {
              systemSuspend
              status
            }
          }
        }
        subscription {
          status
          transactionDate
        }
        currentUserWorkspace {
          id
          status
          identity
          workspace {
            id
            logo {
              id
              url
            }
          }
        }
        kycVerified
        hasCompleted
        preferredContactMethodReminderAt
      }
    }
  }
`;

export const NUMBER_REPORT_ANALYTICS = gql`
  query NumberReportAnalytic($channelId: Int, $fromDate: DateTime, $toDate: DateTime) {
    numberReportAnalytic(channelId: $channelId, fromDate: $fromDate, toDate: $toDate) {
      message
      data {
        callType
        count
        percentage
      }
    }
  }
`;

export const NUMBER_REPORT_TABLE = gql`
  query DashboardNumberAnalytics(
    $fromDate: DateTime!
    $toDate: DateTime!
    $offset: Int
    $sort: SortEnum
    $order: String
    $query: String
  ) {
    dashboardNumberAnalytics(
      fromDate: $fromDate
      toDate: $toDate
      offset: $offset
      sort: $sort
      order: $order
      query: $query
    ) {
      message
      edges {
        id
        phoneNumber
        isActive
        members {
          id
          name
          profileUrl
        }
        teams {
          id
          name
        }
        totalCalls
        duration
        country {
          id
          name
          slug
          dialingCode
          alphaTwoCode
          alphaThreeCode
          numeric
          flag
        }
        emergencyStatus
        channelName
        strategies {
          strategySlug
        }
      }
      count
    }
  }
`;

export const QUERY_AI_DASHBOARD_MEMBER_PERFORMANCE = gql`
  query aiDashboardMemberPerformance(
    $sentimentType: String!
    $fromDate: Date!
    $toDate: Date!
    $limit: Int
    $offset: Int
  ) {
    aiDashboardMemberPerformance(
      sentimentType: $sentimentType
      fromDate: $fromDate
      toDate: $toDate
      limit: $limit
      offset: $offset
    ) {
      message
      count
      data {
        userName
        totalCallCount
        percentage
        userWorkspaceId
        transcribeCallCount
        transcribeSpecificSentimentCount
        averageDuration
      }
    }
  }
`;

export const QUERY_MEMBER_DASHBOARD_REPORT_ANALYTICS = gql`
  query MemberDashboardReportAnalytics(
    $fromDate: DateTime!
    $toDate: DateTime!
    $limit: Int
    $order: String
    $sort: SortEnum
    $offset: Int
    $query: String
  ) {
    memberDashboardReportAnalytics(
      fromDate: $fromDate
      toDate: $toDate
      limit: $limit
      order: $order
      sort: $sort
      offset: $offset
      query: $query
    ) {
      message
      edges {
        id
        role
        status
        isActive
        teams {
          id
          name
        }
        user {
          id
          name
          phoneNumber
          profileUrl
        }
        channel {
          id
          friendlyName
          phoneNumber
        }
        outbound
        missed
        inbound
        averageCallDuration
        totalCallDuration
      }
      count
    }
  }
`;

export const CHANNEL_BY_ID = gql`
  query Channel($channelId: Int!) {
    channel(id: $channelId) {
      data {
        id
        friendlyName
        phoneNumber
        numberType
        country {
          id
          flag
          alphaTwoCode
        }
      }
      message
    }
  }
`;

export const GRAPH_NUMBER_REPORT = gql`
  query NumberGraphReportAnalytics($channelId: Int!, $fromDate: DateTime!, $toDate: DateTime!) {
    numberGraphReportAnalytics(channelId: $channelId, fromDate: $fromDate, toDate: $toDate) {
      message
      data {
        year
        month
        missed
        outbound
        inbound
        totalCalls
      }
    }
  }
`;

export const QUERY_DASHBOARD_REPORT_ANALYTIC = gql`
  query DashboardReportAnalytic($fromDate: DateTime!, $toDate: DateTime!, $userWorkspaceId: Int, $channelId: Int) {
    dashboardReportAnalytic(
      fromDate: $fromDate
      toDate: $toDate
      userWorkspaceId: $userWorkspaceId
      channelId: $channelId
    ) {
      data {
        callType
        count
        percentage
      }
      message
    }
  }
`;

export const QUERY_INDIVIDUAL_MEMBER_DASHBOARD_REPORT_ANALYTICS = gql`
  query IndividualMemberDashboardReportAnalytics(
    $fromDate: DateTime!
    $toDate: DateTime!
    $userWorkspaceId: Int!
    $limit: Int
    $order: String
    $sort: SortEnum
    $offset: Int
    $query: String
  ) {
    individualMemberDashboardReportAnalytics(
      fromDate: $fromDate
      toDate: $toDate
      userWorkspaceId: $userWorkspaceId
      limit: $limit
      order: $order
      sort: $sort
      offset: $offset
      query: $query
    ) {
      message
      count
      edges {
        id
        name
        phoneNumber
        callType
        callDate
        callDuration
      }
    }
  }
`;

export const NUMBER_REPORT_AGGREGATED_STATISTICS = gql`
  query NumberAggregatedReportAnalytics($channelId: Int!, $fromDate: DateTime!, $toDate: DateTime!) {
    numberAggregatedReportAnalytics(channelId: $channelId, fromDate: $fromDate, toDate: $toDate) {
      message
      data {
        key
        value {
          callDuration
          percentage
        }
      }
    }
  }
`;

export const GET_CHANNEL_MEMBERS = gql`
  query ChannelMembers($channelId: Int!) {
    channelMembers(channelId: $channelId) {
      message
      data {
        name
        userId
        url
      }
    }
  }
`;

export const INDIVIDUAL_NUMBER_REPORT = gql`
  query IndividualNumberReportAnalytics(
    $channelId: Int!
    $fromDate: DateTime!
    $toDate: DateTime!
    $limit: Int
    $offset: Int
    $sort: SortEnum
    $order: String
    $query: String
  ) {
    individualNumberReportAnalytics(
      channelId: $channelId
      fromDate: $fromDate
      toDate: $toDate
      limit: $limit
      offset: $offset
      sort: $sort
      order: $order
      query: $query
    ) {
      message
      count
      edges {
        id
        name
        phoneNumber
        callDate
        callDuration
        callType
      }
    }
  }
`;

export const QUERY_AI_ADVANCE_CALL_REPORT = gql`
  query aiAdvanceCallReport(
    $fromDate: Date!
    $toDate: Date!
    $limit: Int
    $offset: Int
    $sentimentType: String
    $reasonType: String
    $conclusionType: String
    $userWorkspaceId: Int
    $order: String
    $sort: SortEnum
    $callType: String
    $callResolution: String
  ) {
    aiAdvanceCallReport(
      fromDate: $fromDate
      toDate: $toDate
      limit: $limit
      offset: $offset
      sentimentType: $sentimentType
      reasonType: $reasonType
      conclusionType: $conclusionType
      userWorkspaceId: $userWorkspaceId
      order: $order
      sort: $sort
      callType: $callType
      callResolution: $callResolution
    ) {
      message
      count
      edges {
        userName
        callDirection
        createdAt
        agentPhoneNumber
        callCount
        callRecordingId
        transcriptionId
        callRecordingUrl
        customerName
        customerPhoneNumber
      }
    }
  }
`;

export const QUERY_WORKSPACE_MEMBERS = gql`
  query workspaceMembers(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: String
    $status: UserWorkspaceStatusEnum
  ) {
    workspaceMembers(first: $first, last: $last, after: $after, before: $before, query: $query, status: $status) {
      pageInfo {
        count
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
      message
      edges {
        node {
          id
          user {
            id
            name
            email
            phoneNumber
            profilePicture {
              id
              url
              originalname
              size
              key
              mimetype
            }
          }
          status
          id
          channels {
            phoneNumber
            id
            friendlyName
          }
          userWorkspaceRoles {
            role {
              level
              label
              id
            }
          }
        }
      }
    }
  }
`;

export const AI_DASHBOARD_COUNT = gql`
  query AiDashboardCount($fromDate: Date!, $toDate: Date!) {
    aiDashboardCount(fromDate: $fromDate, toDate: $toDate) {
      message
      data {
        sentiment
        totalCount
        percentage
      }
    }
  }
`;

export const AI_DASHBOARD_REPORT_ANALYTICS = gql`
  query AiDashboardReportAnalytics($fromDate: Date!, $toDate: Date!) {
    aiDashboardReportAnalytics(fromDate: $fromDate, toDate: $toDate) {
      message
      data {
        key
        value {
          count
          percentage
          duration
          label
        }
      }
    }
  }
`;

export const GET_TRANSCRIPTION_INFORMATION = gql`
  query GetTranscriptionInformation($callRecordingId: Int) {
    getTranscriptionInformation(callRecordingId: $callRecordingId) {
      message
      data {
        callSummary
        sentiment
        reason
        conclusion
        resolutions
        recommendations
        callRecordingUrl
        transcriptionText {
          content
          participantRole
          sentiment
        }
        memberTalkTime
        customerTalkTime
        silenceTime
        totalTalkTime
        availableSentiments
      }
    }
  }
`;

export const QUERY_AI_DASHBOARD_DAYWISE_SENTIMENT = gql`
  query AiDashboardDayWiseSentiment($fromDate: Date!, $toDate: Date!) {
    aiDashboardDayWiseSentiment(fromDate: $fromDate, toDate: $toDate) {
      message
      data {
        createdAt
        positiveSentimentCount
        negativeSentimentCount
        neutralSentimentCount
      }
    }
  }
`;

export const QUERY_AI_DASHBOARD_MEMBER_PERFORMANCE_GRAPH = gql`
  query AiDashboardMemberPerformanceGraphReport($limit: Int, $fromDate: Date!, $toDate: Date!) {
    aiDashboardMemberPerformanceGraphReport(limit: $limit, fromDate: $fromDate, toDate: $toDate) {
      message
      data {
        userId
        userName
        percentage
        totalCallCount
      }
    }
  }
`;

export const QUERY_WORKSPACE_MEMBER = gql`
  query WorkspaceMember($workspaceMemberId: Int!) {
    workspaceMember(id: $workspaceMemberId) {
      message
      data {
        id
        user {
          id
          name
          email
          profilePicture {
            id
            url
          }
        }
        userOnlineManagement {
          isActive
          lastSeenAt
          activeStatus
          awayTill
          message
          icon
        }
      }
    }
  }
`;

export const QUERY_ASSIGN_CHANNELS = gql`
  query assignChannels($first: Int, $query: String) {
    assignChannels(first: $first, query: $query) {
      edges {
        node {
          id
          isDefault
          channel {
            id
            unreadCountChannel
            friendlyName
            phoneNumber
            identity
            muted
            setting {
              id
              voicemail
              recording
            }
            a2pVerified
            country {
              id
              flag
            }
          }
          userWorkspace {
            id
            status
            user {
              id
              name
            }
          }
        }
      }
      message
    }
  }
`;

export const RECENT_MESSAGE_CONVERSATION = gql`
  query RecentMessageConversations(
    $channelId: Int!
    $after: String
    $first: Int
    $query: String
    $markAsClosed: Boolean
    $sort: SortEnum
    $order: String
    $voicemail: Boolean
    $direction: DirectionTypeEnum
    $conversationStatus: [String]
  ) {
    recentMessageConversations(
      channelId: $channelId
      after: $after
      first: $first
      query: $query
      markAsClosed: $markAsClosed
      sort: $sort
      order: $order
      voicemail: $voicemail
      direction: $direction
      conversationStatus: $conversationStatus
    ) {
      edges {
        node {
          id
          updatedAt
          unreadCountRecentMessage
          draftMessage
          channel {
            id
          }
          client {
            id
            name
            phoneNumber
            country {
              id
              flag
            }
            profilePicture {
              id
              url
            }
          }
          markAsClosed
          messageConversation {
            id
            conversationType
            conversationStatus
            direction
            messageContent
            pinned
            voicemailRecordingUrl
          }
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
    }
  }
`;

export const QUERY_PLAN_PRICES = gql`
  query PlanPrices(
    $periodicity: PeriodicityEnum
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: String
  ) {
    planPrices(periodicity: $periodicity, first: $first, last: $last, after: $after, before: $before, query: $query) {
      message
      edges {
        node {
          id
          amount
          periodicity
          isPublished
          rank
          plan {
            id
            label
            name
            slug
            shortDescription
            description
            features
            recommendation
            showAmount
          }
          position
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
    }
  }
`;

export const GET_CONTACT_BY_ID = gql`
  query ContactById($contactId: Int!) {
    contact(id: $contactId) {
      message
      data {
        id
        isBlocked
        name
        phoneNumber
        isBlocked
        country {
          id
          flag
        }
        profilePicture {
          id
          url
        }
      }
    }
  }
`;

export const MARK_AS_OPEN_CLOSE = gql`
  mutation MarkConversationAsCloseOrOpen($markAsCloseOrOpenId: Int!, $input: InputMarkAsCloseOrOpen) {
    markAsCloseOrOpen(id: $markAsCloseOrOpenId, input: $input) {
      message
    }
  }
`;

export const QUERY_CHANNELS = gql`
  query Channels($first: Int, $last: Int, $after: String, $before: String, $query: String) {
    channels(first: $first, last: $last, after: $after, before: $before, query: $query) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
        __typename
      }
      message
      edges {
        cursor
        node {
          id
          friendlyName
          phoneNumber
          identity
          emergencyStatus
          beta
          country {
            id
            flag
          }
          capability {
            voice
            __typename
          }
          channelUserWorkspaces {
            id
            userWorkspace {
              id
              user {
                id
                name
                profilePicture {
                  id
                  url
                  originalname
                  size
                  key
                  mimetype
                  __typename
                }
                __typename
              }
              status
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const QUERY_REGULATORY_COMPLIANCES = gql`
  query RegulatoryCompliances($first: Int, $last: Int, $after: String, $before: String, $query: String) {
    regulatoryCompliances(first: $first, last: $last, after: $after, before: $before, query: $query) {
      message
      pageInfo {
        count
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        __typename
      }
      edges {
        cursor
        node {
          id
          createdAt
          updatedAt
          numberType
          status
          country {
            id
            name
            flag
            alphaTwoCode
            __typename
          }
          channelRequested {
            addressRequirements
            isoCountry
            phoneNumber
            friendlyName
            region
            rateCenter
            capabilities {
              voice
              SMS
              MMS
              __typename
            }
            numberType
            basePrice
            currentPrice
            supportingDocument
            endUser
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const QUERY_IN_PROCESS_PHONE_NUMBERS = gql`
  query InProcessPhoneNumbers(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: String
    $sort: SortEnum
    $order: String
  ) {
    inProcessPhoneNumbers(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
      sort: $sort
      order: $order
    ) {
      message
      pageInfo {
        count
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        __typename
      }
      edges {
        cursor
        node {
          id
          status
          country {
            id
            name
            flag
            alphaTwoCode
          }
          meta {
            phoneNumber
            isoCountry
            friendlyName
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const GET_NUMBER_LIST = gql`
  query availablePhoneNumbers(
    $countryCode: String!
    $numberType: NumberTypeEnum
    $smsEnabled: Boolean
    $voiceEnabled: Boolean
    $mmsEnabled: Boolean
    $faxEnabled: Boolean
    $excludeAllAddressRequired: Boolean
    $excludeLocalAddressRequired: Boolean
    $excludeForeignAddressRequired: Boolean
    $beta: Boolean
    $contains: String
    $areaCode: Int
    $inLocality: String
  ) {
    availablePhoneNumbers(
      countryCode: $countryCode
      numberType: $numberType
      smsEnabled: $smsEnabled
      voiceEnabled: $voiceEnabled
      mmsEnabled: $mmsEnabled
      faxEnabled: $faxEnabled
      excludeAllAddressRequired: $excludeAllAddressRequired
      excludeLocalAddressRequired: $excludeLocalAddressRequired
      excludeForeignAddressRequired: $excludeForeignAddressRequired
      beta: $beta
      contains: $contains
      areaCode: $areaCode
      inLocality: $inLocality
    ) {
      message
      edges {
        addressRequirements
        isoCountry
        phoneNumber
        friendlyName
        region
        rateCenter
        capabilities {
          voice
          SMS
          MMS
        }
        numberType
        basePrice
        currentPrice
        supportingDocument
        endUser
      }
    }
  }
`;

export const QUERY_SETTINGS_MEMBERS_LIST = gql`
  query workspaceMembers(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: String
    $status: UserWorkspaceStatusEnum
  ) {
    workspaceMembers(first: $first, last: $last, after: $after, before: $before, query: $query, status: $status) {
      pageInfo {
        count
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
      message
      edges {
        node {
          id
          user {
            id
            name
            email
            phoneNumber
            profilePicture {
              id
              url
              originalname
              size
              key
              mimetype
            }
          }
          status
          id
          channels {
            phoneNumber
            id
            friendlyName
          }
          userWorkspaceRoles {
            role {
              level
              label
              id
            }
          }
        }
      }
    }
  }
`;

export const PIN_UNPIN_MESSAGE_CONVERSATION = gql`
  mutation PinOrUnpinMessageConversation(
    $pinOrUnpinMessageConversationId: Int!
    $input: InputPinUnpinMessageConversation
  ) {
    pinOrUnpinMessageConversation(id: $pinOrUnpinMessageConversationId, input: $input) {
      message
      data {
        id
        pinned
      }
    }
  }
`;

export const GET_CONTACT_BY_PHONE_NUMBER = gql`
  query GetContactByPhoneNumber($phoneNumber: String!) {
    getContactByPhoneNumber(phoneNumber: $phoneNumber) {
      message
      data {
        address
        companyName
        email
        id
        isBlocked
        blockedBy {
          name
          phoneNumber
          id
        }
        isPublished
        name
        phoneNumber
        country {
          id
          name
          flag
        }
        profilePicture {
          id
          url
        }
        timeZone
        website
        tags {
          id
          label
          color
        }
      }
    }
  }
`;

export const QUERY_TEAMS = gql`
  query Teams($query: String) {
    teams(query: $query) {
      message
      pageInfo {
        count
      }
      edges {
        node {
          id
          name
          status
          totalMembers
          teamMembers {
            user {
              profilePicture {
                id
                url
              }
              name
              id
            }
            status
            userId
          }
        }
      }
    }
  }
`;

export const QUERY_WORKSPACE_MEMBERS_LIST = gql`
  query WorkspaceMembersList($orderBy: [OrderByInput], $first: Int) {
    accepted: workspaceMembers(status: accepted, orderBy: $orderBy, first: $first) {
      message
      edges {
        node {
          id
          user {
            phoneNumber
            name
            id
            email
            profilePicture {
              id
              url
              originalname
              size
              key
              mimetype
            }
          }
          userOnlineManagement {
            isActive
            lastSeenAt
            activeStatus
            awayTill
            message
            icon
          }
          userWorkspaceRoles {
            role {
              label
            }
          }
          identity
        }
      }
    }
  }
`;

export const QUERY_TEAM_MEMBERS = gql`
  query TeamMembers($teamId: String!, $first: Int, $query: String, $after: String) {
    teamMembers(teamId: $teamId, first: $first, query: $query, after: $after) {
      message
      edges {
        node {
          userId
          workspacesId
          teamId
          status
          user {
            id
            name
            email
            phoneNumber
            profilePicture {
              id
              url
              originalname
              size
              key
              mimetype
              createdAt
            }
            address
            dueIn
            accountStatus
            timezone
            averageRiskScore
            totalMonthlyFee
            language
          }
          id
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
    }
  }
`;

export const GET_BLOCKED_LIST = gql`
  query GetBlockedContacts(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: String
    $order: String
    $sort: SortEnum
  ) {
    getBlockedContacts(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
      order: $order
      sort: $sort
    ) {
      pageInfo {
        count
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      message
      edges {
        cursor
        node {
          profilePicture {
            url
          }
          blockedBy {
            name
          }
          timeZone
          blockedOn
          blockReason
          id
          phoneNumber
          name
          isBlocked
          isPublished
        }
      }
    }
  }
`;

export const QUERY_ACTIVE_WORKSPACES = gql(`
	query ActiveWorkspaces {
  activeWorkspaces {
    message
    edges {
kycVerified
      hasCompleted
      active
      workspaceDetails {
        planPrice {
          amount
        }
      }
      id
      label
      isCurrent
      status
      logo {
        id
        url
      }
      unreadCountWorkspace
      pkReference
    }
  }
}
`);

export const PROVIDER_LOGIN = gql`
  query ProviderLogin {
    providerLogin {
      message
      data {
        token {
          access
        }
      }
    }
  }
`;
export const QUERY_COMMAND_RESPONSES = gql`
  query CommandResponses($query: String) {
    commandResponses(query: $query) {
      edges {
        node {
          command
          content
          id
          title
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
      message
    }
  }
`;

export const VERIFY_PROMO_CODE = gql`
  query VerifyPromoCode($input: InputVerifyPromoCode!) {
    verifyPromoCode(input: $input) {
      data {
        isValid
        discountAmount
        discountPercentage
        discountType
      }
      message
    }
  }
`;

export const GET_INVOICES = gql`
  query Invoices {
    invoices {
      message
      edges {
        cursor
        node {
          id
          type
          status
          totalAmount
          invoiceNo
          transactionId
          transactionDate
          invoiceItems {
            id
            invoiceId
            amount
            quantity
            remarks
            numberType
            country {
              id
              name
              slug
              dialingCode
              alphaTwoCode
              alphaThreeCode
              numeric
              flag
            }
          }
          billingCycleDate
          customer {
            email
            billingAddress {
              first_name
              last_name
              company
              phone
              line1
              line2
              city
              state
              country
              zip
            }
          }
          currency
          paymentMode {
            firstName
            lastName
            last4
            expiryMonth
            expiryYear
            brand
          }
          creditsApplied
          subTotalAmount
          discountPercentage
          discountAmount
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
    }
  }
`;

export const CONTACT_NOTES = gql`
  query ContactNotes(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $contactId: Int
    $order: String
    $sort: SortEnum
  ) {
    contactNotes(
      first: $first
      last: $last
      after: $after
      before: $before
      contactId: $contactId
      order: $order
      sort: $sort
    ) {
      message
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
      edges {
        cursor
        node {
          id
          description
          createdAt
          updatedAt
          updatedBy {
            id
            user {
              id
              name
              profilePicture {
                url
              }
            }
          }
        }
      }
    }
  }
`;

export const VALIDATE_ACTIVATION_CODE = gql`
  query ValidateActivationCode($email: String!, $code: String!) {
    validateActivationCode(email: $email, code: $code) {
      message
      data {
        id
        email
        code
        billingPlanPricesId
        createdAt
        updatedAt
        deletedAt
        expiresAt
        usedAt
        billingPlanPrices {
          id
          amount
          periodicity
          isPublished
          position
          rank
          plan {
            id
            label
            name
            slug
            shortDescription
            description
            features
            recommendation
            showAmount
          }
        }
      }
    }
  }
`;

export const TAGS = gql`
  query Tags($first: Int, $last: Int, $after: String, $before: String, $query: String) {
    tags(first: $first, last: $last, after: $after, before: $before, query: $query) {
      message
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        count
      }
      edges {
        cursor
        node {
          id
          label
          slug
          type
          color
        }
      }
    }
  }
`;

export const CONTACT_TAGS = gql`
  query ContactTags($first: Int, $last: Int, $after: String, $before: String, $contactId: Int, $sort: SortEnum) {
    contactTags(first: $first, last: $last, after: $after, before: $before, contactId: $contactId, sort: $sort) {
      message
      pageInfo {
        count
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          contactId
          tags {
            id
            label
            slug
            type
            color
          }
        }
      }
    }
  }
`;

export const QUERY_ASSIGN_CHANNELS_COUNT = gql`
  query GetAssignedChannelsCount {
    getAssignedChannelsCount {
      message
      count
    }
  }
`;

export const QUERY_CONTACTS = gql`
  query Contacts($first: Int, $sort: SortEnum, $order: String, $nameStartsWith: String, $after: String) {
    contacts(first: $first, sort: $sort, order: $order, nameStartsWith: $nameStartsWith, after: $after) {
      message
      edges {
        cursor
        node {
          id
          name
          phoneNumber
          profilePicture {
            id
            url
            originalname
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        startCursor
      }
    }
  }
`;

export const QUERY_CONTACT = gql`
  query Contact($contactId: Int!) {
    contact(id: $contactId) {
      message
      data {
        id
        name
        phoneNumber
        email
        address
        website
        companyName
        timeZone
        sourceType
        profilePicture {
          id
          url
          originalname
        }
        country {
          id
          flag
          name
        }
      }
    }
  }
`;

export const QUERY_LIST_PAYMENT_SOURCE = gql`
  query ListPaymentSource {
    listPaymentSource {
      message
      data {
        id
        referenceId
        isPrimary
        isSecondary
        gatewayAccountId
        card {
          firstName
          lastName
          last4
          expiryMonth
          expiryYear
          brand
        }
        paymentGateway
        status
        paypal {
          email
        }
      }
    }
  }
`;

export const QUERY_CUSTOMER_BILLING_ADDRESS = gql`
  query CustomerBillingAddress {
    customerBillingAddress {
      data {
        billingAddress {
          first_name
          last_name
          name
          company
          phone
          line1
          line2
          city
          state
          country
          zip
        }
        vatNumber
      }
      message
    }
  }
`;

export const QUERY_LIST_SUBSCRIPTION = gql`
  query ListSubscription {
    listSubscription {
      message
      edges {
        id
        customerId
        status
        currentTermEnd
        nextBillingAt
        createdAt
        cancelledAt
        updatedAt
        deleted
        cancelScheduleCreatedAt
        mrr
        itemCount
        itemProductFamily
        discountItems {
          discountType
          discountAmount
          discountPercentage
        }
        subscriptionItems {
          itemPriceId
          itemType
          quantity
          unitPrice
          amount
        }
        billingPeriodUnit
        remainingBillingCycles
        hasScheduledChanges
        scheduledChanges {
          id
          billingPeriodUnit
          remainingBillingCycles
          customerId
          status
          currentTermEnd
          nextBillingAt
          createdAt
          cancelledAt
          updatedAt
          cancelScheduleCreatedAt
          deleted
          currencyCode
          subscriptionItems {
            itemPriceId
            itemType
            quantity
            unitPrice
            amount
          }
          mrr
          itemProductFamily
          itemCount
        }
      }
    }
  }
`;

export const QUERY_FETCH_JOURNAL_ENTRIES = gql`
  query FetchJournalEntries(
    $transactionDateFrom: Date!
    $transactionDateTo: Date!
    $fields: [String]
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $credit: Boolean
    $debit: Boolean
    $chargeType: [ChargeTypeEnum]
    $messageConversationDirection: [DirectionTypeEnum]
    $usageType: [UsageTypeEnum]
  ) {
    fetchJournalEntries(
      transactionDateFrom: $transactionDateFrom
      transactionDateTo: $transactionDateTo
      fields: $fields
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      credit: $credit
      debit: $debit
      chargeType: $chargeType
      messageConversationDirection: $messageConversationDirection
      usageType: $usageType
    ) {
      data {
        balance
        creditAmount
        currencyCode
        debitAmount
        duration
        from
        id
        remarks
        to
        transactionDate
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const QUERY_GET_AUTO_RECHARGE_CONFIG = gql`
  query GetAutoRechargeConfigs {
    getAutoRechargeConfigs {
      message
      data {
        enabled
        creditThreshold
        credit
        targetBalance
        isDisableAllowed
      }
    }
  }
`;

export const QUERY_GET_LOW_BALANCE_ALERT = gql`
  query GetLowBalanceAlert {
    getLowBalanceAlert {
      message
      data {
        isEmail
        balanceThreshold
      }
    }
  }
`;

export const QUERY_GET_NOTIFICATION_COUNT = gql`
  query ObtainNotificationCount {
    obtainNotificationCount {
      data
    }
  }
`;

export const QUERY_SEARCH_CONVERSATION = gql`
  query SearchMessageConversations(
    $clientId: Int!
    $channelId: Int!
    $query: String!
    $cursor: String
    $limit: Int
    $sort: SortEnum
    $direction: CursorDirectionEnum
    $order: String
  ) {
    searchMessageConversations(
      clientId: $clientId
      channelId: $channelId
      query: $query
      cursor: $cursor
      limit: $limit
      sort: $sort
      direction: $direction
      order: $order
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        cursor
      }
    }
  }
`;

export const QUERY_CONTACT_COUNT = gql`
  query GetContactsCount($query: String, $sourceType: [ContactSourceTypeEnum], $countryCode: [String], $tags: [Int]) {
    getContactsCount(query: $query, sourceType: $sourceType, countryCode: $countryCode, tags: $tags) {
      count
      message
    }
  }
`;

export const QUERY_SEARCH_MESSAGE_CONVERSATION = gql`
  query CountMessageConversations($clientId: Int!, $channelId: Int!, $query: String!) {
    countSearchMessageConversations(clientId: $clientId, channelId: $channelId, query: $query) {
      count
    }
  }
`;

export const QUERY_CONTACT_SOURCE_TYPES = gql`
  query ContactSourceTypes {
    contactSourceTypes {
      message
      data {
        sourceType
      }
    }
  }
`;

export const QUERY_CHECK_MEMBER_EMAIL_EXIST = gql`
  query CheckMemberEmailExist($email: String!) {
    checkMemberEmailExist(email: $email) {
      message
      data {
        exists
      }
    }
  }
`;

export const EXPORT_WALLET_USAGE = gql`
  query ExportJournalEntries(
    $transactionDateFrom: Date!
    $transactionDateTo: Date!
    $credit: Boolean
    $chargeType: [ChargeTypeEnum]
    $messageConversationDirection: [DirectionTypeEnum]
    $usageType: [UsageTypeEnum]
    $fields: [String]
  ) {
    exportJournalEntries(
      transactionDateFrom: $transactionDateFrom
      transactionDateTo: $transactionDateTo
      credit: $credit
      chargeType: $chargeType
      messageConversationDirection: $messageConversationDirection
      usageType: $usageType
      fields: $fields
    ) {
      message
    }
  }
`;

export const QUERY_FETCH_SINGLE_RECENT_MESSAGE = gql`
  query FetchSingleRecentMessageConversation($channelId: Int, $phoneNumber: String) {
    fetchSingleRecentMessageConversation(channelId: $channelId, phoneNumber: $phoneNumber) {
      data {
        id
        client {
          id
        }
      }
    }
  }
`;

export const QUERY_PIN_MESSAGE_COUNT = gql`
  query CountPinnedMessageConversations($clientId: Int!, $channelId: Int!) {
    countPinnedMessageConversations(clientId: $clientId, channelId: $channelId) {
      count
    }
  }
`;

export const QUERY_GET_MEMBER_ROOM = gql`
  query GetMemberRoom($input: InputRoom!) {
    getMemberRoom(input: $input) {
      message
      data {
        id
        label
        identity
        type
        isPublic
      }
    }
  }
`;

export const QUERY_COUNT_MEMBER_SEARCH_CONVERSATION = gql`
  query CountSearchChatMessages($roomId: Int!, $query: String!) {
    countSearchChatMessages(roomId: $roomId, query: $query) {
      count
    }
  }
`;

export const QUERY_MEMBER_PIN_MESSAGE_COUNT = gql`
  query CountPinnedChatMessages($roomId: Int!) {
    countPinnedChatMessages(roomId: $roomId) {
      count
      message
    }
  }
`;

export const QUERY_SEARCH_MEMBER_CONVERSATION = gql`
  query SearchChatMessages(
    $roomId: Int!
    $query: String!
    $cursor: String
    $order: String
    $sort: SortEnum
    $withCursor: Boolean
    $direction: CursorDirectionEnum
    $limit: Int
  ) {
    searchChatMessages(
      roomId: $roomId
      query: $query
      cursor: $cursor
      order: $order
      sort: $sort
      withCursor: $withCursor
      direction: $direction
      limit: $limit
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        id
        cursor
      }
    }
  }
`;

export const QUERY_COUNT_TEAMS = gql`
  query CountTeams($query: String) {
    countTeams(query: $query) {
      count
      message
    }
  }
`;

export const QUERY_ACTIVE_WORKSPACE_V2 = gql`
  query ActiveWorkspacesV2($cursor: String, $withCursor: Boolean, $limit: Int, $query: String, $sort: SortEnum) {
    activeWorkspacesV2(cursor: $cursor, withCursor: $withCursor, limit: $limit, query: $query, sort: $sort) {
      cursor {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      data {
        active
        availableBalance
        id
        isCurrent
        label
        logo {
          url
          id
        }
        numberOfUsers
        owner {
          accountStatus
          coverProfilePicture {
            url
            id
          }
          id
          lastPasswordResetAt
          name
          roles {
            id
            isActive
            label
          }
        }
        status
        unreadCountWorkspace
      }
    }
  }
`;

export const QUERY_COUNT_MEMBERS = gql`
  query CountMembers($query: String) {
    countMembers(query: $query) {
      data {
        key
        value
      }
      message
    }
  }
`;
export const QUERY_MMS_ATTACHMENTS = gql`
  query MessageAttachments($friendlyName: String!) {
    messageAttachments(friendlyName: $friendlyName) {
      message
      data {
        id
        identity
        mimetype
        url
      }
    }
  }
`;

export const QUERY_GET_DRAFT_MESSAGE = gql`
  query draftMessage($clientId: Int!, $channelId: Int!) {
    draftMessage(clientId: $clientId, channelId: $channelId) {
      data {
        id
        messageContent
        createdAt
        updatedAt
        medias {
          id
          url
          mimetype
          size
        }
      }
      message
    }
  }
`;
export const QUERY_INVOICES_V2 = gql`
  query InvoicesV2(
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
    $status: InvoiceStatusEnum
    $transactionDateFrom: Date
    $transactionDateTo: Date
  ) {
    invoicesV2(
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
      status: $status
      transactionDateFrom: $transactionDateFrom
      transactionDateTo: $transactionDateTo
    ) {
      message
      data {
        id
        type
        status
        totalAmount
        invoiceNo
        transactionId
        transactionDate
        billingCycleDate
        currency
        creditsApplied
        subTotalAmount
        discountPercentage
        discountAmount
        totalRefundedAmount
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const INVOICE = gql`
  query Invoice($invoiceId: Int) {
    invoice(id: $invoiceId) {
      message
      data {
        id
        invoiceNo
        status
        transactionDate
        transactionId
        type
        billingCycleDate
        currency
        totalAmount
        subTotalAmount
        creditsApplied
        discountPercentage
        discountAmount
        customer {
          email
          billingAddress {
            city
            company
            country
            first_name
            last_name
            state
            phone
          }
          vatNumber
        }
        invoiceItems {
          id
          amount
          invoiceId
          quantity
          remarks
          numberType
          country {
            name
          }
          phoneNumbers
          meta
        }
      }
    }
  }
`;

export const QUERY_USER_ONLINE_STATUS = gql`
  query GetUserOnlineStatus($userWorkspaceId: Int) {
    getUserOnlineStatus(userWorkspaceId: $userWorkspaceId) {
      data {
        activeStatus
        awaySet
        awayTill
        icon
        message
      }
    }
  }
`;

export const QUERY_CART_LIST = gql`
  query Carts {
    carts {
      message
      data {
        addressRequirements
        isoCountry
        friendlyName
        phoneNumber
        region
        rateCenter
        capabilities {
          voice
          SMS
          MMS
        }
        endUser
        supportingDocument
        currentPrice
        basePrice
        numberType
      }
    }
  }
`;

export const QUERY_REGULATORY_COMPLIANCE = gql`
  query CheckRegulatoryCompliance($isoCountry: String!, $numberType: NumberTypeEnum!, $addressRequirements: String!) {
    checkRegulatoryCompliance(
      isoCountry: $isoCountry
      numberType: $numberType
      addressRequirements: $addressRequirements
    ) {
      message
      data {
        regulatoryCompliance
        approvedRegulatoryCompliance {
          identity
          address
          endUserTypes
        }
        requiredRegulatoryCompliance {
          identity
          address
          endUserTypes
        }
      }
    }
  }
`;

export const QUERY_CLAIM_NUMBER_CONFIGURATION = gql`
  query CheckConfigurationAndRewardOfChannel {
    checkConfigurationAndRewardOfChannel {
      message
      data {
        availableRewardCount
        requiresDisposition
      }
    }
  }
`;

export const QUERY_INTEGRATION = gql`
  query Integration($integrationId: Int) {
    integration(id: $integrationId) {
      message
      data {
        id
        name
        description
        domain
        logoUrl
        label
        integrationUser {
          id
          status
        }
      }
    }
  }
`;

export const GET_PAYMENT_REQUEST_TOKEN = gql`
  query GetPaymentRequestToken($invoiceId: Int!) {
    getPaymentRequestToken(invoiceId: $invoiceId) {
      message
      data {
        urlToken
      }
    }
  }
`;
export const QUERY_INTEGRATION_COUNT = gql`
  query IntegrationCount {
    integrationCount {
      message
      data {
        key
        value
      }
    }
  }
`;

export const GET_MEMBER_SUBSCRIPTION = gql`
  query GetMemberSubscription {
    getMemberSubscription {
      message
      data {
        id
        memberPlanId
        status
        nextBillingAt
        endedAt
        plan {
          id
          label
        }
        totalAmount
        itemsQuantity
        periodUnit
      }
    }
  }
`;
export const QUERY_INTEGRATION_CONFIGURATION = gql`
  query IntegrationConfiguration($integrationConfigurationId: Int!) {
    integrationConfiguration(id: $integrationConfigurationId) {
      message
      data {
        id
        integrationUserId
        workspaceId
        syncCallDetails
        syncContacts
        syncMessage
        syncVoicemails
        syncRecordings
        createdBy
        updatedBy
      }
    }
  }
`;
export const QUERY_INTEGRATION_WEBHOOKS = gql`
  query IntegrationWebhooks($integrationUserId: Int!) {
    integrationWebhooks(integrationUserId: $integrationUserId) {
      message
      data {
        id
        integrationUserId
        label
        username
        password
        url
      }
    }
  }
`;

export const QUERY_MY_ROLE_PRIVILEGE = gql`
  query MyRolePrivilege {
    myRolePrivilege {
      edges {
        module {
          slug
        }
        privilege {
          slug
        }
        role {
          slug
        }
        screen {
          slug
        }
      }
    }
  }
`;

export const COUNT_CHANNELS = gql`
  query CountChannels($isFree: Boolean, $query: String) {
    freeNumbers: countChannels(isFree: $isFree) {
      message
      count
    }
    totalNumbers: countChannels(isFree: null, query: $query) {
      message
      count
    }
  }
`;
export const QUERY_MY_PLAN_PRIVILEGE = gql`
  query MyPlanPrivilege {
    myPlanPrivilege {
      message
      edges {
        privilege {
          slug
        }
        screen {
          slug
        }
        module {
          slug
        }
      }
    }
  }
`;

export const QUERY_GET_ASSIGNED_CHANNELS = gql`
  query GetAssignedChannels($userWorkspaceId: Int!, $query: String) {
    getAssignedChannels(userWorkspaceId: $userWorkspaceId, query: $query) {
      message
      data {
        channel {
          friendlyName
          phoneNumber
          id
          muted
        }
      }
    }
  }
`;

export const QUERY_GET_BUSINESS_HOUR = gql`
  query GetBusinessHoursInCallSetting($callSettingId: Int!) {
    getBusinessHoursInCallSetting(callSettingId: $callSettingId) {
      message
      data {
        id
        timezoneId
        isAlwaysOpen
        entries {
          localDayOfWeek
          localStartTime
          localEndTime
          businessHourId
          isActive
        }
        timezone {
          value
          label
          id
        }
      }
    }
  }
`;

export const QUERY_MY_WORKSPACE = gql`
  query MyWorkspace {
    myWorkspace {
      data {
        id
        label
        logo {
          id
          url
        }
        totalPhoneNumbers
        coverProfile {
          url
          id
        }
        availableBalance
      }
    }
  }
`;

export const QUERY_GET_WALLET_DETAILS_WITH_LAST_CREDITED = gql`
  query GetWalletDetailsWithLastCredited {
    getWalletDetailsWithLastCredited {
      data {
        amount
        lastCredit
        lastTransactionDate
      }
      message
    }
  }
`;

export const QUERY_ENUMERATE_COUNTRIES_FOR_AVAILABLE_NUMBERS = gql`
  query EnumerateCountriesForAvailableNumbers($query: String) {
    enumerateCountriesForAvailableNumbers(query: $query) {
      message
      data {
        id
        name
        slug
        dialingCode
        alphaTwoCode
        alphaThreeCode
        numeric
        flag
      }
    }
  }
`;

export const QUERY_ENUMERATE_NUMBER_TYPES_AVAILABLE_FOR_COUNTRY = gql`
  query EnumerateNumberTypesAvailableForCountry($countryCode: String!) {
    enumerateNumberTypesAvailableForCountry(countryCode: $countryCode) {
      message
      data {
        id
        label
      }
    }
  }
`;

export const QUERY_GET_CALL_SETTING = gql`
  query GetCallSetting($getCallSettingId: Int!) {
    getCallSetting(id: $getCallSettingId) {
      message
      data {
        id
        friendlyName
        isBusinessAlwaysOpen
        afterHour
        ivr
        voicemail
        welcomeMessage
        recording
        callerTune
        callForward
        callTransfer
        callerId
        timeout
        enableMissedCallEmail
        smsMmsEmailAlertEnabled
        transcriptionEmailAlertEnabled
      }
    }
  }
`;

export const QUERY_GET_AFTER_HOURS = gql`
  query GetBusinessAfterHoursInCallSetting($callSettingId: Int!) {
    getBusinessAfterHoursInCallSetting(callSettingId: $callSettingId) {
      message
      data {
        id
        route
        supportAfterHours
        voicemailAudioPrompt {
          id
          text
          language
          gender
          audio {
            id
            url
          }
          type
        }
        targetPhoneNumber
        updatedAt
      }
    }
  }
`;

export const QUERY_MEMBER_SUBSCRIPTION_OVERVIEW = gql`
  query GetMemberSubscriptionOverview {
    getMemberSubscriptionOverview {
      data {
        id
        totalAmount
        userCount
        plan {
          id
          amount
          periodicity
          label
        }
        discount {
          percent
        }
        promo {
          label
          percent
        }
      }
    }
  }
`;

export const QUERY_GET_IVR_PROMPT = gql`
  query GetIvrInCallSetting($callSettingId: Int!) {
    getIvrInCallSetting(callSettingId: $callSettingId) {
      message
      data {
        id
        isActive
        startPrompt {
          text
          language
          gender
          audio {
            id
            url
          }
          type
        }
        invalidPrompt {
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
        ifUnansweredPrompt {
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
      }
    }
  }
`;

export const QUERY_CALL_FORWARD = gql`
  query GetCallForwardInCallSetting($callSettingId: Int!) {
    getCallForwardInCallSetting(callSettingId: $callSettingId) {
      message
      data {
        id
        isUnconditional
        targetPhoneNumber
        isActive
      }
    }
  }
`;

export const QUERY_GET_SCHEDULED_MESSAGES_COUNT = gql`
  query GetMessageScheduleCount($channelId: Int!, $clientId: Int!, $status: [MessageScheduleStatusEnum]) {
    getMessageScheduleCount(channelId: $channelId, clientId: $clientId, status: $status) {
      message
      data {
        scheduleAt
        id
        count
      }
    }
  }
`;
export const QUERY_ESTIMATE_RENEW_FAILED_SUBSCRIPTION = gql`
  query EstimateRenewFailedSubscriptionV2 {
    estimateRenewFailedSubscriptionV2 {
      message
      data {
        estimatedAmount
      }
    }
  }
`;
export const QUERY_GET_CALL_SETTTING = gql`
  query GetCallTransferInCallSetting($callSettingId: Int!) {
    getCallTransferInCallSetting(callSettingId: $callSettingId) {
      message
      data {
        id
        isActive
        transferPrompt {
          id
          defaultUrl
          useDefault
          workspaceId
          text
          language
          gender
          audio {
            id
            url
          }
          type
        }
        noAnswerPrompt {
          id
          defaultUrl
          useDefault
          workspaceId
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
        terminatedPrompt {
          id
          defaultUrl
          useDefault
          workspaceId
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
      }
    }
  }
`;

export const QUERY_GET_CALLER_ID = gql`
  query GetCallerIdInCallSetting($callId: Int!) {
    getCallerIdInCallSetting(id: $callId) {
      message
      data {
        id
        callerIdInfo {
          id
        }
      }
    }
  }
`;

export const QUERY_RING_DURATION = gql`
  query GetTimeoutInCallSetting($getTimeoutInCallSettingId: Int!) {
    getTimeoutInCallSetting(id: $getTimeoutInCallSettingId) {
      message
      data {
        id
        timeout
      }
    }
  }
`;

export const QUERY_CALLER_TUNE = gql`
  query GetCallerTuneInCallSetting($getCallerTuneInCallSettingId: Int!) {
    getCallerTuneInCallSetting(id: $getCallerTuneInCallSettingId) {
      message
      data {
        id
        isActive
        audioPrompt {
          id
          workspaceId
          text
          language
          gender
          audio {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          type
        }
        callerTuneLoop
      }
    }
  }
`;

export const QUERY_WELCOME_MESSAGE = gql`
  query GetWelcomeMessageInCallSetting($getWelcomeMessageInCallSettingId: Int!) {
    getWelcomeMessageInCallSetting(id: $getWelcomeMessageInCallSettingId) {
      message
      data {
        id
        isActive
        audioPrompt {
          id
          workspaceId
          text
          language
          gender
          audio {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          type
        }
      }
    }
  }
`;

export const QUERY_WORKSPACE_RATE_LIMIT = gql`
  query WorkspaceRateLimits {
    workspaceRateLimits {
      message
      data {
        id
        category
        direction
        threshold
        timeLimit
        segmentLimit
        exhaust {
          value
        }
      }
    }
  }
`;

export const QUERY_WORKSPACE_A2P_VERIFICATION_STATUS = gql`
  query WorkspaceA2PVerificationStatus {
    workspaceA2PVerificationStatus {
      message
      data {
        a2pVerified
      }
    }
  }
`;

export const QUERY_GET_CONTACT_COMPLIANCE_CONSENT = gql`
  query GetContactComplianceConsent($getContactComplianceConsentId: Int!) {
    getContactComplianceConsent(id: $getContactComplianceConsentId) {
      message
      data {
        id
        consentedAt
        isConsented
        consentSource
        consentDetails
        campaign {
          id
          messageServiceName
        }
        flowDetails
      }
    }
  }
`;

export const QUERY_GET_NUMBER_CALLER_ID = gql`
  query GetCallerIdInChannelSetting($channelId: Int!) {
    getCallerIdInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        callerIdInfo {
          id
        }
      }
    }
  }
`;

export const QUERY_NUMBER_CALL_FORWARD = gql`
  query GetCallForwardInChannelSetting($channelId: Int!) {
    getCallForwardInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        isUnconditional
        targetPhoneNumber
        isActive
      }
    }
  }
`;

export const QUERY_GET_AUTO_TRANSCRIBE_IN_CALL_SETTING = gql`
  query GetAutoTranscribeInCallSetting($getAutoTranscribeInCallSettingId: Int!) {
    getAutoTranscribeInCallSetting(id: $getAutoTranscribeInCallSettingId) {
      message
      data {
        id
        autoTranscribe
      }
    }
  }
`;

export const QUERY_GET_RECORDING_ANNOUNCEMENT_IN_CALL_SETTINGS = gql`
  query GetRecordingAnnouncementInCallSetting($getRecordingAnnouncementInCallSettingId: Int!) {
    getRecordingAnnouncementInCallSetting(id: $getRecordingAnnouncementInCallSettingId) {
      message
      data {
        recordingAnnouncementMessage
        recordingAnnouncementAfterBeep
        id
        audioPrompt {
          audio {
            url
            id
          }
          id
          gender
          language
          text
          type
          workspaceId
        }
      }
    }
  }
`;

export const QUERY_GET_AUTO_RECORDING_IN_CALL_SETTINGS = gql`
  query GetAutoRecordingInCallSetting($getAutoRecordingInCallSettingId: Int!) {
    getAutoRecordingInCallSetting(id: $getAutoRecordingInCallSettingId) {
      message
      data {
        id
        autoRecording
      }
    }
  }
`;

export const QUERY_NUMBER_WELCOME_MESSAGE = gql`
  query GetWelcomeMessageInChannelSetting($channelId: Int!) {
    getWelcomeMessageInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        isActive
        audioPrompt {
          id
          workspaceId
          text
          language
          gender
          audio {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          type
        }
      }
    }
  }
`;

export const QUERY_NUMBER_RING_DURATION = gql`
  query GetTimeoutInChannelSetting($channelId: Int!) {
    getTimeoutInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        timeout
      }
    }
  }
`;

export const QUERY_NUMBER_CALLER_TUNE = gql`
  query GetCallerTuneInChannelSetting($channelId: Int!) {
    getCallerTuneInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        isActive
        audioPrompt {
          id
          workspaceId
          text
          language
          gender
          audio {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          type
        }
        callerTuneLoop
      }
    }
  }
`;

export const QUERY_GET_VOICEMAIL_IN_CALL_SETTINGS = gql`
  query GetVoicemailInCallSetting($getVoicemailInCallSettingId: Int!) {
    getVoicemailInCallSetting(id: $getVoicemailInCallSettingId) {
      message
      data {
        voicemailAfterBeep
        sendVoicemailToEmail
        isActive
        id
        audioPrompt {
          type
          text
          language
          id
          gender
          audio {
            url
            id
            mimetype
          }
          workspaceId
        }
      }
    }
  }
`;
export const QUERY_NUMBER_GET_CALL_SETTTING = gql`
  query GetCallTransferInChannelSetting($channelId: Int!) {
    getCallTransferInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        isActive
        transferPrompt {
          id
          defaultUrl
          useDefault
          workspaceId
          text
          language
          gender
          audio {
            id
            url
          }
          type
        }
        noAnswerPrompt {
          id
          defaultUrl
          useDefault
          workspaceId
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
        terminatedPrompt {
          id
          defaultUrl
          useDefault
          workspaceId
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
      }
    }
  }
`;

export const QUERY_GET_VOICEMAIL_IN_CHANNEL_SETTINGS = gql`
  query GetVoicemailInChannelSetting($channelId: Int!) {
    getVoicemailInChannelSetting(channelId: $channelId) {
      message
      data {
        voicemailAfterBeep
        sendVoicemailToEmail
        isActive
        id
        audioPrompt {
          type
          text
          language
          id
          gender
          audio {
            url
            id
            mimetype
          }
          workspaceId
        }
      }
    }
  }
`;

export const QUERY_NUMBER_GET_AUTO_RECORDING_IN_CALL_SETTINGS = gql`
  query GetAutoRecordingInChannelSetting($channelId: Int!) {
    getAutoRecordingInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        autoRecording
      }
    }
  }
`;

export const QUERY_NUMBER_GET_AUTO_TRANSCRIBE_IN_CALL_SETTING = gql`
  query GetAutoTranscribeInChannelSetting($channelId: Int!) {
    getAutoTranscribeInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        autoTranscribe
      }
    }
  }
`;

export const QUERY_NUMBER_GET_RECORDING_ANNOUNCEMENT_IN_CALL_SETTINGS = gql`
  query GetRecordingAnnouncementInChannelSetting($channelId: Int!) {
    getRecordingAnnouncementInChannelSetting(channelId: $channelId) {
      message
      data {
        recordingAnnouncementMessage
        recordingAnnouncementAfterBeep
        id
        audioPrompt {
          audio {
            url
            id
          }
          id
          gender
          language
          text
          type
          workspaceId
        }
      }
    }
  }
`;

export const QUERY_NUMBER_GET_IVR_PROMPT = gql`
  query GetIvrInChannelSetting($channelId: Int!) {
    getIvrInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        isActive
        startPrompt {
          text
          language
          gender
          audio {
            id
            url
          }
          type
        }
        invalidPrompt {
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
        ifUnansweredPrompt {
          text
          language
          gender
          createdAt
          type
          audio {
            id
            url
          }
        }
      }
    }
  }
`;

export const QUERY_NUMBER_GET_BUSINESS_HOUR = gql`
  query GetBusinessHoursInChannelSetting($channelId: Int!) {
    getBusinessHoursInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        isAlwaysOpen
        entries {
          localDayOfWeek
          localStartTime
          localEndTime
          businessHourId
          isActive
        }
        timezone {
          value
          label
          id
        }
      }
    }
  }
`;

export const QUERY_NUMBER_GET_CALL_SETTING = gql`
  query GetChannelSetting($channelId: Int!) {
    getChannelSetting(channelId: $channelId) {
      message
      data {
        id
        friendlyName
        callTransfer
        isBusinessAlwaysOpen
        afterHour
        ivr
        timeout
        voicemail
        welcomeMessage
        recording
        callerTune
        callForward
        enableMissedCallEmail
        smsMmsEmailAlertEnabled
        transcriptionEmailAlertEnabled
        callerId
      }
    }
  }
`;

export const QUERY_NUMBER_GET_AFTER_HOURS = gql`
  query GetBusinessAfterHoursInChannelSetting($channelId: Int!) {
    getBusinessAfterHoursInChannelSetting(channelId: $channelId) {
      message
      data {
        id
        route
        supportAfterHours
        voicemailAudioPrompt {
          id
          text
          language
          gender
          audio {
            id
            url
          }
          type
        }
        targetPhoneNumber
        updatedAt
      }
    }
  }
`;

export const QUERY_GET_CHANNEL_OVERVIEW = gql`
  query GetChannelOverview($channelId: Int!) {
    getChannelOverview(channelId: $channelId) {
      message
      data {
        id
        friendlyName
        phoneNumber
        country {
          id
          flag
          alphaTwoCode
        }
        callSetting {
          id
          businessHourType
          friendlyName
          incomingTimeout
          recording
          metrics {
            key
            value
          }
          callerId {
            id
            friendlyName
            phoneNumber
          }
        }
        subscription {
          nextBillingAt
        }
        channelGroup {
          id
          name
          callSetting {
            id
            businessHourType
            metrics {
              key
              value
            }
            friendlyName
            recording
            incomingTimeout
            callerId {
              id
              friendlyName
              phoneNumber
            }
          }
        }
        removalSchedule {
          scheduleAt
        }
        assignedUsers {
          id
          name
          profilePicture {
            id
            url
          }
        }
      }
    }
  }
`;
export const QUERY_FETCH_ACTIVE_CHANNEL_STRATEGIES = gql`
  query FetchActiveChannelStrategies($channelId: Int!) {
    fetchActiveChannelStrategies(channelId: $channelId) {
      data
    }
  }
`;

export const QUERY_DASHBOARD_KPI_LIST = gql`
  query DashboardKpis($input: InputFromDateToDateUserId) {
    dashboardKpis(input: $input) {
      data {
        answerRate {
          name
          slug
          value {
            answerRate
            changePercent
            currentAnsweredCall
            currentTotalInbound
            previousAnsweredCall
            previousTotalInbound
          }
        }
        averageAnswerTime {
          name
          slug
          value {
            changePercent
            currentAverageAns
            previousAverageAns
          }
        }
        totalCall {
          name
          slug
          value {
            currentInboundCall
            currentOutboundCall
            previousInboundCall
            previousOutboundCall
            inboundCallChangePercent
            outboundCallChangePercent
          }
        }
        closedConversation {
          name
          slug
          value {
            changePercent
            currentClosedConversation
            previousClosedConversation
          }
        }
        liveCall {
          name
          slug
          value {
            liveCallCount
            peakCount
          }
        }
        totalMessage {
          name
          slug
          value {
            currentInboundMess
            currentOutboundMess
            previousInboundMess
            previousOutboundMess
            inboundMessChangePercent
            outboundMessChangePercent
          }
        }
        missedCall {
          name
          slug
          value {
            changePercent
            percentOfInbound
            currentMissedCallValue
            previousMissedCallValue
          }
        }
        openedConversation {
          name
          slug
          value {
            changePercent
            currentOpenConversation
            previousOpenConversation
          }
        }
      }
      message
    }
  }
`;

export const QUERY_DASHBOARD_CALL_VOLUME = gql`
  query DashboardCallVolume($input: InputFromDateToDateUserId) {
    dashboardCallVolume(input: $input) {
      data {
        timeBucket
        outboundCount
        inboundCount
      }
      message
    }
  }
`;

export const QUERY_DASHBOARD_UNIQUE_VS_REPEATED_CALLER = gql`
  query DashboardUniqueVsRepeatedCaller($input: InputFromDateToDateUserId) {
    dashboardUniqueVsRepeatedCaller(input: $input) {
      data {
        timeBucket
        uniqueCount
        repeatedCount
      }
      message
    }
  }
`;

export const QUERY_DASHBOARD_MEMBER_LEADERBOARD = gql`
  query DashboardMemberLeaderBoard($input: InputFromDateToDate) {
    dashboardMemberLeaderBoard(input: $input) {
      data {
        userId
        userName
        userMediaUrl
        callFlowName
        callFlowId
        totalCalls
        totalMessages
        total
      }
      message
    }
  }
`;

export const QUERY_DASHBOARD_CALL_DISTRIBUTIONS = gql`
  query DashboardCallDistributions($input: InputFromDateToDateUserId) {
    dashboardCallDistributions(input: $input) {
      data {
        channelId
        channelFriendlyName
        channelMediaUrl
        channelPhoneNumber
        totalCalls
        callPercentage
      }
      message
    }
  }
`;

export const QUERY_DASHBOARD_KEY_KPIS = gql`
  query DashboardKeyKpis($input: InputFromDateToDateUserId) {
    dashboardKeyKpis(input: $input) {
      data {
        totalCalls
        missedCalls
        answerRate
        averageAnswerTime
        message
        recordingCoverage
        transcriptionCoverage
      }
      message
    }
  }
`;

export const QUERY_DASHBOARD_WALLET_EXPENDITURES = gql`
  query DashboardWalletExpenditure($input: InputFromDateToDateUserId) {
    dashboardWalletExpenditure(input: $input) {
      data {
        spentSection
        amountSpent
      }
      message
    }
  }
`;

export const QUERY_DASHBOARD_CRITICAL_EVENTS = gql`
  query DashboardCriticalEvents {
    dashboardCriticalEvents {
      data {
        message
        event
      }
      message
    }
  }
`;

export const QUERY_UNLIMITED_CONFIGS = gql`
  query UnlimitedConfigs {
    unlimitedConfigs {
      message
      data {
        id
        direction
        threshold
        consumedThreshold
        unit
      }
    }
  }
`;

export const QUERY_DASHBOARD_UNLIMITED_USAGES = gql`
  query DashboardUnlimitedUsages($input: InputUserId) {
    dashboardUnlimitedUsages(input: $input) {
      data {
        endingAt
        freeCreditWorth
        incoming {
          call
          message
          messageCount
          callCount
          messageThreshold
          callThreshold
        }
        outgoing {
          call
          message
          callCount
          messageCount
          callThreshold
          messageThreshold
        }
        hasUnlimitedConfig
      }
      message
    }
  }
`;

export const QUERY_DASHBOARD_AFTER_HOUR_ACTIVITIES = gql`
  query DashboardAfterHourActivities($input: InputFromDateToDateUserId) {
    dashboardAfterHourActivities(input: $input) {
      data {
        date
        call
        message
      }
      message
    }
  }
`;

export const GET_CALL_SETTING_FOR_CHANNEL = gql`
  query GetCallSettingForChannel($channelId: Int!) {
    getCallSettingForChannel(channelId: $channelId) {
      data {
        callSetting {
          callTransfer
          recording
        }
        id
      }
    }
  }
`;

export const CHANNEL_GROUPS_COUNT = gql`
  query ChannelGroupsCount($query: String) {
    channelGroupsCount(query: $query) {
      message
      data {
        count
      }
    }
  }
`;

export const QUERY_GET_CALL_SETTINGS_COUNT = gql`
  query GetCallSettingsCount($query: String) {
    getCallSettingsCount(query: $query) {
      message
      data {
        count
      }
    }
  }
`;

export const QUERY_GET_CONFIGURATION = gql`
  query GetConfiguration($key: String!) {
    getConfiguration(key: $key) {
      message
      data
    }
  }
`;

export const QUERY_LIVE_CALL_COUNT = gql`
  query LiveConferenceCount {
    liveConferenceCount {
      message
      count
    }
  }
`;

export const NUMBERS_COUNT = gql`
  query PhoneNumberStatusCount($query: String) {
    phoneNumberStatusCount(query: $query) {
      message
      data {
        activeCount
        pendingCount
        failedCount
        releasedAndScheduledChannelsCount
      }
    }
  }
`;

export const QUERY_PUBLIC_CHECK_NUMBER_REGULATION = gql`
  query PublicCheckPhoneNumberRegulation(
    $isoCountry: String!
    $numberType: NumberTypeEnum!
    $addressRequirements: String!
  ) {
    publicCheckPhoneNumberRegulation(
      isoCountry: $isoCountry
      numberType: $numberType
      addressRequirements: $addressRequirements
    ) {
      message
      data {
        regulatoryCompliance
        requiredRegulatoryCompliance {
          identity
          address
          endUserTypes
        }
      }
    }
  }
`;

export const QUERY_GET_PREFERRED_CONTACT_METHODS = gql`
  query GetPreferredContactMethods {
    getPreferredContactMethods {
      message
      data {
        id
        messagingEnabled
        messagingType
        messagingNumber
        phoneCallEnabled
        phoneCallNumber
        prefStartTime
        prefEndTime
        emailEnabled
        email
      }
    }
  }
`;

export const QUERY_USAGE_REPORT_NOTIFICATION = gql`
  query UsageReportNotification {
    usageReportNotification {
      message
      data {
        frequency
        localSendAt
        localDayOfWeek
        localDayOfMonth
        localWeekOfMonth
        localWeekdayOfMonth
        localMonthOfYear
        monthlyScheduleType
        enabled
      }
    }
  }
`;

export const QUERY_AGENT_IN_PROGRESS_CONVERSATION = gql`
  query AgentInProgressConversation {
    agentInProgressConversation {
      message
      data {
        id
        callEntity {
          id
          sid
          clientIdentity
          callPlatform
        }
      }
    }
  }
`;

export const QUERY_GET_BULK_MESSAGING_CAMPAIGN = gql`
  query GetBulkMessagingCampaign($campaignId: Int!) {
    getBulkMessagingCampaign(campaignId: $campaignId) {
      message
      data {
        id
        campaignName
        isDraft
        messageTemplate
        mediaCount
        campaignType
        messagingType
        a2pCampaignId
        a2pCampaignType
        a2pSampleId
        status
        scheduleType
        isScheduled
        initiatedAt
        scheduledAt
        maxOccurrence
        endAt
        recipients {
          id
          name
          phoneNumber
          profile {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
        }
        attachments {
          id
          fileName
          mimetype
          fileSize
          fileUrl
          media {
            id
          }
        }
        metrics {
          key
          value
        }
        createdBy {
          id
          name
          profilePicture {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          roles {
            id
            label
            slug
            level
            isActive
            isDefault
            position
          }
        }
        createdAt
        nextOccurrence
        deliverySummary {
          totalRecipients
          totalDelivered
          runStatus
          totalSent
        }
        channel {
          id
          phoneNumber
        }
      }
    }
  }
`;

export const QUERY_GET_BULK_CAMPAIGN_RECIPIENTS = gql`
  query FetchBulkMessagingCampaignRecipients(
    $campaignId: Int!
    $sort: SortEnum
    $cursor: String
    $direction: CursorDirectionEnum
    $limit: Int
    $withCursor: Boolean
    $order: String
    $query: String
    $status: BulkMessagingCampaignRecipientStatusEnum
  ) {
    fetchBulkMessagingCampaignRecipients(
      campaignId: $campaignId
      sort: $sort
      cursor: $cursor
      direction: $direction
      limit: $limit
      withCursor: $withCursor
      order: $order
      query: $query
      status: $status
    ) {
      message
      data {
        id
        conversationStatus
        contact {
          id
          country {
            id
            name
            flag
          }
          profilePicture {
            id
            url
          }
          phoneNumber
          name
        }
        messageConversationErrorLog {
          id
          code
          message
        }
        createdAt
        updatedAt
      }
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const QUERY_GET_BULK_MESSAGING_CAMPAIGN_LIST_COUNT = gql`
  query GetBulkMessagingCampaignListCount(
    $campaignType: BulkMessagingCampaignTypeEnum
    $status: [BulkMessagingCampaignStatusEnum]
    $createdBy: [Int]
    $query: String
    $initiatedFrom: Date
    $initiatedTo: Date
  ) {
    getBulkMessagingCampaignListCount(
      campaignType: $campaignType
      status: $status
      createdBy: $createdBy
      query: $query
      initiatedFrom: $initiatedFrom
      initiatedTo: $initiatedTo
    ) {
      count
      message
    }
  }
`;

export const QUERY_WORKSPACE_CLAIMED_FREE_NUMBERS = gql`
  query WorkspaceClaimedFreeNumbers {
    workspaceClaimedFreeNumbers {
      message
      data {
        id
        phoneNumber
        friendlyName
        currentPrice
      }
    }
  }
`;

export const QUERY_GET_RECIPIENTS_BY_CAMPAIGN_RUN = gql`
  query GetRecipientsByCampaignRun(
    $campaignRunId: Int!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
    $status: String
  ) {
    getRecipientsByCampaignRun(
      campaignRunId: $campaignRunId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
      status: $status
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        updatedAt
        id
        createdAt
        conversationStatus
        contact {
          id
          email
          name
          phoneNumber
          profilePicture {
            id
            url
            originalname
            size
            key
            mimetype
            createdAt
          }
          country {
            id
            name
            slug
            dialingCode
            alphaTwoCode
            alphaThreeCode
            numeric
            flag
          }
        }
        messageConversationErrorLog {
          id
          code
          message
        }
      }
    }
  }
`;

export const QUERY_GET_CAMPAIGN_RECIPIENTS_BY_CAMPAIGN_ID = gql`
  query GetCampaignRecipientsByCampaignId(
    $campaignId: Int!
    $cursor: String
    $direction: CursorDirectionEnum
    $withCursor: Boolean
    $limit: Int
    $order: String
    $sort: SortEnum
    $query: String
  ) {
    getCampaignRecipientsByCampaignId(
      campaignId: $campaignId
      cursor: $cursor
      direction: $direction
      withCursor: $withCursor
      limit: $limit
      order: $order
      sort: $sort
      query: $query
    ) {
      message
      cursor {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      data {
        updatedAt
        id
        createdAt
        contact {
          id
          email
          country {
            id
            name
            flag
          }
          name
          phoneNumber
          profilePicture {
            id
            key
            url
          }
        }
      }
    }
  }
`;

export const QUERY_GET_CALL_SETTING_EMAIL_ALERTS = gql`
  query GetCallSettingEmailAlerts($getCallSettingEmailAlertsId: Int!) {
    getCallSettingEmailAlerts(id: $getCallSettingEmailAlertsId) {
      message
      data {
        enableMissedCallEmail
        smsMmsEmailAlertEnabled
        transcriptionEmailAlertEnabled
      }
    }
  }
`;

export const QUERY_GET_CHANNEL_SETTING_EMAIL_ALERTS = gql`
  query GetChannelSettingEmailAlerts($channelId: Int!) {
    getChannelSettingEmailAlerts(channelId: $channelId) {
      message
      data {
        enableMissedCallEmail
        smsMmsEmailAlertEnabled
        transcriptionEmailAlertEnabled
      }
    }
  }
`;

export const QUERY_GET_BULK_MESSAGING_CAMPAIGN_RUN = gql`
  query GetBulkMessagingCampaignRun($campaignRunId: Int!) {
    getBulkMessagingCampaignRun(campaignRunId: $campaignRunId) {
      message
      data {
        updatedAt
        totalRecipients
        status
        startedAt
        scheduledAt
        runNumber
        initiatedAt
        id
        campaign {
          campaignType
          id
          messageTemplate
          name
          phoneNumber
        }
        completedAt
        createdAt
        createdBy {
          id
          name
        }
        deliverySummary {
          totalProcessed
          totalSent
          totalFailed
          totalDelivered
        }
      }
    }
  }
`;

export const QUERY_GET_CHANNELS_BY_CAMPAIGN = gql`
  query GetChannelsByCampaign($campaignId: Int!, $type: ContactComplianceConsentCampaignTypeEnum!) {
    getChannelsByCampaign(campaignId: $campaignId, type: $type) {
      message
      data {
        id
        phoneNumber
        friendlyName
      }
    }
  }
`;

export const QUERY_GET_COMPLIANCE_CAMPAIGN_SAMPLE_MESSAGES = gql`
  query GetComplianceCampaignSampleMessages($campaignId: Int!, $type: ContactComplianceConsentCampaignTypeEnum!) {
    getComplianceCampaignSampleMessages(campaignId: $campaignId, type: $type) {
      message
      data {
        id
        message
      }
    }
  }
`;

export const QUERY_GET_PAYMENT_ORDER_BY_ID = gql`
  query GetPaymentOrderById($paymentOrderId: Int!) {
    getPaymentOrderById(paymentOrderId: $paymentOrderId) {
      message
      data {
        id
        orderNumber
        cartAmount
        chargedAmount
        status
        lienStatus
        type
        remarks
        itemsQuantity
        createdAt
      }
    }
  }
`;

export const QUERY_RELEASED_AND_SCHEDULED_CHANNELS = gql`
  query ReleasedAndScheduledChannels(
    $query: String
    $countryIds: [Int]
    $numberTypes: [String]
    $channelStatus: ReleasedChannelFilterEnum
  ) {
    releasedAndScheduledChannels(
      query: $query
      countryIds: $countryIds
      numberTypes: $numberTypes
      channelStatus: $channelStatus
    ) {
      message
      data {
        id
        friendlyName
        phoneNumber
        releasedAt
        country {
          id
          flag
          alphaTwoCode
        }
        removalSchedule {
          scheduleAt
        }
        subscription {
          nextBillingAt
        }
        numberType
      }
    }
  }
`;
